import { isSavedAnalysis } from '@modules/analysis/helpers';
import { useRenameAnalysis } from '@modules/analysis/hooks/useRenameAnalysis';
import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { ArtefactTitle } from '@modules/common/components/ArtefactTitle';
import { useIsArtefactEditable } from '@modules/common/hooks';
import { ArtefactType } from '@modules/common/types';
import { Divider, Stack } from '@mui/material';
import dayjs from 'dayjs';
import { shallow } from 'zustand/shallow';

export const SearchTitle = () => {
  const name = useAnalysisStore(({ title }) => title);
  const analysisMetadata = useAnalysisStore(({ metadata }) => metadata);
  const handleRenameSearch = useRenameAnalysis({ analysisMetadata });
  const { id, createdBy, updatedAt, editToken, status } = useAnalysisStore(
    ({ id, editToken, createdBy, updatedAt, status }) => ({
      id,
      createdBy,
      updatedAt,
      status,
      editToken,
    }),
    shallow,
  );
  const isEditable = useIsArtefactEditable({
    editToken,
    status,
  });

  const isSavedFeed = isSavedAnalysis(id);

  const canRenameArtefact = isEditable && isSavedFeed;

  const feedName = isSavedFeed ? name : 'New Feed';

  const creatorName =
    createdBy && isSavedFeed
      ? `${createdBy?.firstName} ${createdBy?.lastName}`
      : '';

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <ArtefactTitle
        name={feedName}
        artefactType={ArtefactType.Search}
        onArtefactRename={canRenameArtefact ? handleRenameSearch : undefined}
        createdBy={creatorName}
        updatedAt={dayjs((updatedAt || 0) * 1000)?.fromNow()}
      />
      <Divider orientation="vertical" flexItem />
    </Stack>
  );
};
